import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./../Navbar";
import Breadcrumb from 'react-bootstrap/Breadcrumb'

const KPILanding = () => (
  <div data-test="kpiManagerLandingComponent" id="background-img">
    <Navbar />
    <Breadcrumb>
      <Breadcrumb.Item href="">
        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
      <Breadcrumb.Item href="">
        <Link to='/welcome'>Welcome</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item href=""  >
        <Link to="/open_loop">Open loop</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item href="/kpi_manager" active >
        KPI Manager
      </Breadcrumb.Item>
    </Breadcrumb>


    <div className="container">
      <div className="row" style={{ paddingTop: "4%" }}>
        <div className="col-md-12 text-center">
          <h1>Welcome to KPI Manager.AD</h1>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row" style={{ paddingTop: "4%" }}>
          <div className="col-md-6">
            <div className="card">
              <div className="card-body" style={{ paddingBottom: "12%" }}>
                <h5 style={{ color: "#753DFF", paddingBottom: "2.5%" }}>
                  <b>Description</b>
                </h5>
                <p className="card-text">
                  A smart database of all applicable KPI’s well defined and
                  generated exhaustively across features and functions. A smart
                  framework which enables selection of respective and applicable
                  KPI’s during feature or function under test. Its not limited
                  to function or feature but has KPI databases for sensors,
                  components and systems as well. The tools is backed up by a
                  powerful analytics engine and data generated during simulation
                  runs/drive tests of any components or solutions can combined
                  with tool to quickly assess them against the relevant KPIs.
                  Once the data is combined, the tool will understand which
                  solution or software component is being tested and will
                  execute analytics and generate results against each KPI.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row" style={{ marginBottom: "5%" }}>
              <div className="col-md-12">
                <div className="card" id="info-box">
                  <div className="card-body align-items-center d-flex justify-content-center">
                    <h4 style={{ color: "#622AD8" }}>Components</h4>
                  </div>
                  <div className="container card-body align-items-center d-flex justify-content-center">
                    <div className="row" style={{ color: "#464646" }}>
                      <div className="col">
                        <Link to={"/camera"}>
                          <button className="btn">Camera</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/lidar"}>
                          <button className="btn">Lidar</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/radar"}>
                          <button className="btn">Radar</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <Link
                    to="/List_of_components"
                    className="link"
                    style={{
                      paddingLeft: "46%",
                      color: "#753dff",
                      fontWeight: "bold",
                    }}
                  >
                    more. . .
                  </Link>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="card" id="info-box">
                  <div
                    className="card-body align-items-center d-flex justify-content-center"
                    style={{ paddingBottom: "3%" }}
                  >
                    <h4 style={{ color: "#622AD8" }}>Function/Feature</h4>
                  </div>
                  <div className="container card-body d-flex justify-content-center">
                    <div className="row" style={{ color: "#464646" }}>
                      <div className="col">
                        <Link to={"/Automatic_Emergency_Braking"}>
                          <button className="btn">AEB</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/Lane_Keeping_Assist"}>
                          <button className="btn">LKA</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/Adaptive_Cruise_Control"}>
                          <button className="btn">ACC</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/Traffic_Sign_Recognition"}>
                          <button className="btn">TSR</button>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="container card-body d-flex justify-content-center">
                    <div className="row" style={{ color: "#464646" }}>
                      <div className="col">
                        <Link to={"/Lane_Change_Assist"}>
                          <button className="btn">LCA</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/Automatic_Emergency_Steering"}>
                          <button className="btn">AES</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to={"/Intelligent_Speed_Adaptation"}>
                          <button className="btn">ISA</button>
                        </Link>
                      </div>

                      <div className="col">
                        <Link
                          to="/List_of_features"
                          className="link"
                          style={{ color: "#753dff", fontWeight: "bold" }}
                        >
                          more...{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

export default KPILanding;
